import { usePathname } from 'next/navigation';

export function useIsClubeIfoodDiscountPage() {
  const pathname: string | null = usePathname();

  const isClubeIfoodDiscountPage = pathname?.includes('clube-ifood/descontos') ?? false;

    return isClubeIfoodDiscountPage;
}
